import { render, staticRenderFns } from "./CourseTeachers.vue?vue&type=template&id=71d7b626&"
import script from "./CourseTeachers.vue?vue&type=script&lang=js&"
export * from "./CourseTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports